var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkbenchWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8754 7.50684L7.14737 11.2348C7.09671 11.2856 7.03655 11.3259 6.97031 11.3533C6.90408 11.3808 6.83307 11.395 6.76137 11.395C6.68966 11.395 6.61866 11.3808 6.55242 11.3533C6.48619 11.3259 6.42602 11.2856 6.37537 11.2348L5.12537 9.98417",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.00684H13C13.2652 3.00684 13.5196 3.11219 13.7071 3.29973C13.8946 3.48727 14 3.74162 14 4.00684V14.5068C14 14.7721 13.8946 15.0264 13.7071 15.2139C13.5196 15.4015 13.2652 15.5068 13 15.5068H3C2.73478 15.5068 2.48043 15.4015 2.29289 15.2139C2.10536 15.0264 2 14.7721 2 14.5068V4.00684C2 3.74162 2.10536 3.48727 2.29289 3.29973C2.48043 3.11219 2.73478 3.00684 3 3.00684H5.5C5.5 2.3438 5.76339 1.70791 6.23223 1.23907C6.70107 0.770228 7.33696 0.506836 8 0.506836C8.66304 0.506836 9.29893 0.770228 9.76777 1.23907C10.2366 1.70791 10.5 2.3438 10.5 3.00684V3.00684Z",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03805 2.50979C8.08692 2.51736 8.13244 2.53926 8.16886 2.57271C8.20528 2.60616 8.23096 2.64965 8.24266 2.6977C8.25436 2.74574 8.25154 2.79618 8.23458 2.84263C8.21761 2.88907 8.18725 2.92944 8.14733 2.95863C8.10742 2.98782 8.05974 3.00452 8.01034 3.00661C7.96093 3.00871 7.91202 2.9961 7.86978 2.97039C7.82754 2.94468 7.79387 2.90702 7.77303 2.86218C7.7522 2.81733 7.74513 2.76732 7.75272 2.71845C7.7629 2.65295 7.79867 2.59417 7.85218 2.55504C7.90569 2.51591 7.97255 2.49963 8.03805 2.50979Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkbenchWhite);
export default __webpack_public_path__ + "static/media/workbench-white.14cac50e2a2dcc0a9b32fbdf3cb895a2.svg";
export { ForwardRef as ReactComponent };